module.exports = __webpack_public_path__ + "img/bb3.fe97243a.jpg";